/**
 * Blog posts section – Latest News design
 * NoTe Theme - Custom Blog Posts
 *
 * Section-specific behavior can be added here.
 * The blog-posts custom element is defined in theme.js.
 */
(function () {
  'use strict';
  // Reserved for future section-specific logic (e.g. card animations)
})();
